import React from 'react';

const ContactIcon = () => (
    <div className='ContactIcon DesktopIcon'>
        <img
            // src='/images/ContactIcon.png'
            src='/images/Finalized/ContactIcon.png'
            alt='Contact'
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
        />
        <span>Contact</span>
    </div>
);

export default ContactIcon;
